module.exports = __webpack_public_path__ + "img/arrow-right-double.02a5d582.svg";